import { styled } from "@mui/material/styles";
//import { styled, alpha } from "@mui/material/styles";
import { Link } from "react-router-dom";
import { makeStyles } from "@mui/styles";

export const styles = {
  genericHeaderStyling: {
    fontStyle: "normal !important",
    fontVariantLigatures: "normal !important",
    fontVariantCaps: "normal !important",
    fontVariantNumeric: "normal !important",
    fontVariantEastAsian: "normal !important",
    fontWeight: "500 !important",
    fontStretch: "normal !important",
    fontSize: "16px !important",
    lineHeight: "1 !important",
    textAlign: "center",
    overflowWrap: "break-word",
    fontFamily:
      '"PingFang SC", "Hiragino Sans GB", "Noto Sans CJK SC", "Source Han Sans SC", "Microsoft YaHei", SimHei, Helvetica, Arial, serif !important',
  },
  container: {
    backgroundColor: "#000000",
    zIndex: "503",
    width: "100%",
    padding: "5px 3% 0px 3%",
    height: "110px",
  },
  containerMobile: {
    backgroundColor: "#000000",
    zIndex: "503",
    width: "100%",
    padding: "0px 3% 0px 3%",
    height: "64px",
  },
  button: {
    marginTop: "0",
    borderRadius: "0",
    padding: "0",
    paddingTop: "20px",
    color: "white",
    display: "block",
    textTransform: "inherit",
    height: "95%",
  },

  navLink: {
    color: "#ffffff",
    textDecoration: "none",
  },

  ul_mobile: {
    display: "flex",
    flexDirection: "column",
    alignItems: "baseline",
    marginLeft: "20%",
    padding: "2%",
  },
  subNavStrip: {
    width: "100%",
    position: "absolute",
    height: "35%",
    backgroundColor: "#1f1f1f",
  },
  li: {
    color: "#fff",
    // '&:hover': {backgroundColor:'white',color:'#000000'},
    "&.list-active": {
      backgroundColor: "#fff",
      color: "#000000",
      "& > div > span": {
        color: "#000000",
      },
    },
  },
};

export const useStyles = makeStyles({
  flexClass: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
    maxWidth: "90px",
  },
  newsSubNavBox: {
    display: "flex",
    width: "100%",
    justifyContent: "space-evenly",
    position: "relative",
  },
  productSubNavBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    position: "relative",
    marginBottom: "8px",
    marginTop: "8px",
    marginRight: "2%",
  },
  multiMegaWrapper: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    height: "100%",
  },
  input: {
    color: "white !important",
    fontFamily: "Roboto, Helvetica, Arial, sans-serif !important",
  },
});

export const LinkComp = styled(Link)(({ mobileview }) => ({
  color: mobileview ? "#000000" : "#ffffff",
  textDecoration: "none",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-around",
  alignItems: mobileview ? "center" : "baseline",
  font: mobileview
    ? 'normal 500 16px/24px "PingFang SC","Hiragino Sans GB","Noto Sans CJK SC","Source Han Sans SC","Microsoft YaHei","SimHei",Helvetica,Arial,serif'
    : 'normal 500 14px/22px "PingFang SC","Hiragino Sans GB","Noto Sans CJK SC","Source Han Sans SC","Microsoft YaHei","SimHei",Helvetica,Arial,serif',
  "&:hover": { color: "#007aff" },
}));

export const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  // backgroundColor: alpha(theme.palette.common.white, 0.15),
  // "&:hover": {
  //   backgroundColor: alpha(theme.palette.common.white, 0.25),
  // },
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("md")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));

export const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const drawerWidth = "100%";
